'use client';

import { Cross1Icon, HamburgerMenuIcon } from '@radix-ui/react-icons';
import * as Toggle from '@radix-ui/react-toggle';
import classNames from 'classnames';
import type { ReactElement } from 'react';
import React from 'react';
import type PropsWithClassname from 'types/props-with-classname';
import { validateString } from 'utils/validate-string';

import styles from './mobile-menu-toggle.module.scss';

const rootClass = validateString(styles.root);

const defaultSize = 25;

interface Props extends PropsWithClassname {
  readonly toggled: boolean;
  readonly onToggle: () => void;
  readonly size?: number | undefined;
}

export function MobileMenuToggle({
  onToggle,
  toggled,
  size = defaultSize,
  className,
}: Props): ReactElement {
  return (
    <Toggle.Root
      aria-label="Menu toggle"
      className={classNames(rootClass, className)}
      onPressedChange={onToggle}
      pressed={toggled}
    >
      {!toggled ? (
        <HamburgerMenuIcon height={size} width={size} />
      ) : (
        <Cross1Icon height={size} width={size} />
      )}
    </Toggle.Root>
  );
}
